const locale = {
    SEARCH: 'Search...',

}

export default locale;